import { Role } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';
import { useRole } from '../../../hooks/useRole';

export const TemplateScoringSystemPrompt = () => {
  const {
    field: { value, onChange },
  } = useController({
    name: 'systemPrompt',
  });

  const hasSupportRole = useRole(Role.Support);
  const [inputValue, setInputValue] = React.useState(value || '');
  const ref = React.useRef(null);

  const onEdit = React.useCallback(
    (value: string) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <ChakraV3.Accordion.Root
      collapsible
      borderWidth='1px'
      borderColor='gray.200'
      borderRadius='xl'
      bg='white'
      overflow='hidden'
      defaultValue={['system-prompt']}
    >
      <ChakraV3.Accordion.Item value='system-prompt' border={0}>
        <ChakraV3.Accordion.ItemTrigger p={0} bg='blue.50' _hover={{ bg: 'blue.50' }}>
          <ChakraV3.HStack w='full' gap={2} px={4} py={4}>
            <ChakraV3.Text fontSize='lg' fontWeight='semibold' color='blue.600'>
              System Prompt
            </ChakraV3.Text>
          </ChakraV3.HStack>
          <ChakraV3.Stack py={2} pr={4}>
            <ChakraV3.Accordion.ItemIndicator />
          </ChakraV3.Stack>
        </ChakraV3.Accordion.ItemTrigger>
        <ChakraV3.Accordion.ItemContent pb={4} pt={2} px={4} ref={ref}>
          <ChakraV3.Editable.Root
            value={inputValue}
            onValueChange={({ value }) => setInputValue(value)}
            onValueCommit={({ value }) => onEdit(value)}
            placeholder='Enter system prompt instructions...'
            activationMode='none'
            className='group'
          >
            <ChakraV3.HStack w='full' align='baseline'>
              <ChakraV3.Editable.Preview
                w='full'
                cursor='pointer'
                textAlign='left'
                p={0}
                rounded='none'
                lineHeight='normal'
                fontSize='sm'
                whiteSpace='pre-wrap'
              />
              <ChakraV3.Editable.Textarea
                as={ChakraV3.Textarea}
                overflow='hidden'
                resize='none'
                lineHeight='normal'
                border='none'
                textAlign='left'
                minH={0}
                p={0}
                fontSize='sm'
                rounded='none'
                h='auto'
                {...{ minRows: 1, rows: 1, autoresize: true }}
              />
              {hasSupportRole && <ChakraV3.EditableControls />}
            </ChakraV3.HStack>
          </ChakraV3.Editable.Root>
        </ChakraV3.Accordion.ItemContent>
      </ChakraV3.Accordion.Item>
    </ChakraV3.Accordion.Root>
  );
};
